module.exports = __webpack_public_path__ + "static/img/logo.a3cf353.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/seo/logo.png
// module id = UR5E
// module chunks = 70